import { render, staticRenderFns } from "./GmbServicesItemBool.vue?vue&type=template&id=172da11e&"
import script from "./GmbServicesItemBool.vue?vue&type=script&lang=js&"
export * from "./GmbServicesItemBool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports